export default {
  gap: {
    xs: '0.5rem',
    sm: '1rem',
    md: '2.5rem',
    lg: '3rem',
    xl: '4rem'
  }
}
